module.exports = __webpack_public_path__ + "assets/7358a7df829341705ebc074667539385.mp4";